import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  WritableSignal,
  linkedSignal,
} from '@angular/core';
import {
  DatetimeCustomEvent,
  ModalController,
} from '@ionic/angular/standalone';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonDatetime } from '@ionic/angular/standalone';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { FieldTree, form, FormField } from '@angular/forms/signals';

interface DatetimeForm {
  date: string;
}

@Component({
  selector: 'lyceo-ui-datetime-modal',
  templateUrl: './datetime-modal.component.html',
  styleUrls: ['./datetime-modal.component.scss'],
  imports: [FontAwesomeModule, IonDatetime, ModalHeaderComponent, FormField],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatetimeModalComponent {
  private readonly modalController: ModalController = inject(ModalController);

  public readonly text: InputSignal<string> = input.required<string>();
  public readonly date: InputSignal<string> = input<string>('');

  private readonly formModel: WritableSignal<DatetimeForm> = linkedSignal(
    () => ({
      date: this.date(),
    }),
  );

  protected form: FieldTree<DatetimeForm> = form(this.formModel);

  protected change(event: DatetimeCustomEvent): void {
    this.modalController.dismiss({
      value: event.detail.value,
    });
  }

  protected submit(event: Event): void {
    event.preventDefault();

    this.modalController.dismiss({
      value: this.form.date().value(),
    });
  }

  protected close(): void {
    this.modalController.dismiss();
  }
}
